module.exports = __webpack_public_path__ + "static/media/iphone-your-shifts.323d622f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone-your-shifts.png
// module id = 348
// module chunks = 0